<template>
  <section class="page">
    <showreject v-if="modalClick" @CloseModal="modalClick = false" />

    <div class="page-header">
      <div class="page-header-start">
        <span
          class="back"
          @click="
            $router.push({
              name: 'approved-jobseeker',
              query: { type: 'Approved', p: 10, q: 1, s: '' },
            })
          "
        >
          <i class="fal fa-chevron-left"></i>
        </span>

        <button
          v-if="status === 'Rejected'"
          @click="Delete()"
          class="button primary"
        >
          Delete User
        </button>

        <h3 v-if="isCheckSeeker" class="page-title">
          {{ seekerName }} {{ seekerLastName }}
        </h3>
      </div>

      <div class="page-header-end">
        <p class="tag" v-if="getCheck === false" @click="Check()">
          Mark as New
        </p>
      </div>
    </div>

    <div class="page-content">
      <div class="page-content-header">
        <div class="page-content-header-start">
          <div class="button-lists">
            <div class="select">
              <select v-model="status">
                <option value="Approved">Approve</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Reject</option>
              </select>
            </div>
          </div>

          <button
            v-if="status === 'Rejected'"
            class="button primary"
            @click="OpenModal(), save(), addPoint()"
          >
            Update
          </button>

          <button
            v-else
            class="button primary"
            @click="changeMobile(), changeStatus(), save(), addPoint()"
          >
            Update
          </button>
        </div>
        <div class="page-content-header-end">
          <div class="field">
            <label for="">CV Point</label>
            <input
              type="text"
              class="input"
              v-model="points"
              placeholder="Enter resume point"
            />
          </div>
        </div>
      </div>
      <div class="box">
        <div class="grids is-12-desktop gap-20-desktop">
          <div class="span-4-desktop">
            <div class="profile">
              <profile :profiles="seekers" v-model="myProfiles" />

              <div>
                <iframe
                  :src="
                    `https://docs.google.com/viewerng/viewer?url=` +
                    PDF +
                    `&embedded=true`
                  "
                  frameborder="0"
                  height="100%"
                  width="100%"
                ></iframe>
              </div>

              <h4 v-if="seekerAll.reason">Reason</h4>

              <textarea
                v-if="seekerAll.reason"
                class="column"
                name=""
                v-model="seekerAll.reason"
                id=""
                disabled
                cols="35"
                rows="10"
              ></textarea>
            </div>
          </div>

          <div class="span-8-desktop">
            <statistics :seeker="seekers" v-model="mySeekers" />
            <!-- <button class="button primary" @click="save()">Save Resume</button> -->

            <div class="cv-card">
              <label class="label">Mobile:</label>
              <input
                type="text"
                v-model="mobile"
                class="input"
                placeholder="xxxxxxxx"
              />
            </div>
            <resumeSummary :resumes="seekers" v-model="myResumes" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  GET_SEEKER_NEW,
  CHANGE_SEEKER_STATUS,
  ADD_POINT,
  UPDATE_SEEKER,
  CHECK,
  DELETE,
  CHECK_EX,
  CHANGE_MOBILE,
} from "@/graphql/seeker/seeker";
import { REUSE } from "@/graphql/manage/query";
import profile from "./seeker-detail/profile";
import statistics from "./seeker-detail/statistics";
import resumeSummary from "./seeker-detail/resume-summary";
import { apolloClient } from "@/services/apollo-client";
import showreject from "@coms/modal/complete.vue";

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    profile,
    statistics,
    resumeSummary,
    showreject,
  },
  data: () => ({
    PDF: "",
    salary: [],
    noexp: true,
    seekerAll: null,
    myProfiles: {},
    mySeekers: {},
    myResumes: {},
    seekers: {
      seeker: {},
      resume: {},
      auth: {},
    },
    modalClick: false,
    status: "Approved",
    points: null,
    mypoint: null,
    loading: true,
    getCheck: false,
    getCheckEX: false,
    seekerName: "",
    seekerLastName: "",
    isCheckSeeker: false,
    mobile: null,
  }),
  computed: {
    // getSelectedCompany() {
    //   return this.salary.find((i) => {
    //     return i.name === this.seekerAll.resume.workingExperience.SalayRangeId.name;
    //   });
    // },
  },
  methods: {
    async querySalary() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "SalaryRange",
        },
      });
      this.salary = res.data.getReuses.map((i, index) => ({
        name: i.name,
        num: index,
      }));
      const mapper = await this.salary.find((i) => {
        return (
          i.name === this.seekerAll.resume.workingExperience.SalayRangeId.name
        );
      });
      // if (this.status !== "Approved" && mapper.name !== "Negotiable") {
      //   if (mapper.name === "1,300,000 - 5,000,000 LAK") {
      //     this.points = (mapper.num * 5) / 5;
      //   } else {
      //     this.points = mapper.num * 5 - 5;
      //   }
      // }
    },
    async save() {
      try {
        let workingU;
        if (this.seekerAll.resume.workingExperience) {
          this.noexp = false;
          workingU = {
            LatestJobTitle: this.myResumes ? this.myResumes.title : "",
            SalayRangeId: this.myResumes.salaryRange,
            pre: this.myResumes.pre,
            previousE: this.myResumes.previousE,
            previousEmployerIndustryId:
              this.myResumes.previousEmployerIndustryId,
            totalWorkingExperience: parseInt(
              this.seekerAll.resume.workingExperience.totalWorkingExperience
            ),
          };
        } else {
          workingU = {};
          this.noexp = true;
        }

        let resumesU;

        if (this.myResumes.file.myFile) {
          resumesU = {
            resumeId: this.seekerAll.resume ? this.seekerAll.resume._id : "",
            file: this.myResumes.file.myFile,
            keySkill: this.myResumes.key.keySkill,
            jobLevelId: this.myResumes.jobLevelId,
            jobFunctionId: this.myResumes.jobFunctionId.map((i) => i._id),
            jobTagId: this.myResumes.jobTagId ? this.myResumes.jobTagId : [],
            skillTagId: this.myResumes.skillTagId,
            additionalTagId: this.myResumes.additionalTagId,
          };
        } else {
          resumesU = {
            resumeId: this.seekerAll.resume ? this.seekerAll.resume._id : "",
            keySkill: this.myResumes.key.keySkill,
            jobLevelId: this.myResumes.jobLevelId,
            jobFunctionId: this.myResumes.jobFunctionId.map((i) => i._id),
            jobTagId: this.myResumes.jobTagId ? this.myResumes.jobTagId : [],
            skillTagId: this.myResumes.skillTagId,
            additionalTagId: this.myResumes.additionalTagId,
          };
        }

        let object;

        if (this.noexp == true) {
          object = {
            registerSeekerId: this.seekerAll.registerSeeker._id
              ? this.seekerAll.registerSeeker._id
              : "",
            seekerId: this.seekerAll._id ? this.seekerAll._id : "",
            dateOfBirth: this.seekerAll.registerSeeker.dateOfBirth,
            firstName: this.seekerAll.registerSeeker.firstName,
            lastName: this.seekerAll.registerSeeker.lastName,
            mobile: this.seekerAll.authId.mobile,
            genderId: this.seekerAll.registerSeeker.genderId._id,
            maritalStatusId: this.seekerAll.registerSeeker.maritalStatusId._id,
            drivingLicenses: this.seekerAll.registerSeeker.drivingLicenses,
            logo: {},
            educatU: this.myResumes.education,
            professionalSummary: this.myResumes.professionalSummary,
            districtId: this.seekerAll.registerSeeker.districtId._id,
            lanU: this.myResumes.lan,
            resumesU,
          };
        } else {
          object = {
            registerSeekerId: this.seekerAll.registerSeeker._id
              ? this.seekerAll.registerSeeker._id
              : "",
            seekerId: this.seekerAll._id ? this.seekerAll._id : "",
            dateOfBirth: this.seekerAll.registerSeeker.dateOfBirth,
            firstName: this.seekerAll.registerSeeker.firstName,
            lastName: this.seekerAll.registerSeeker.lastName,
            mobile: this.seekerAll.authId.mobile,
            genderId: this.seekerAll.registerSeeker.genderId._id,
            maritalStatusId: this.seekerAll.registerSeeker.maritalStatusId._id,
            drivingLicenses: this.seekerAll.registerSeeker.drivingLicenses,
            logo: {},
            educatU: this.myResumes.education,
            professionalSummary: this.myResumes.professionalSummary,
            districtId: this.seekerAll.registerSeeker.districtId._id,
            lanU: this.myResumes.lan,
            resumesU,
            workingU,
          };
        }
        //   console.log(object)

        await apolloClient.mutate({
          mutation: UPDATE_SEEKER,
          variables: object,
        });
      } catch (e) {
        return e;
      }
    },
    async Check() {
      const res = await apolloClient.mutate({
        mutation: CHECK,
        variables: {
          seekerId: this.seekerAll._id,
        },
      });
      this.getCheck = res.data.markRead.CVStatus;
    },
    async CheckEX() {
      const res = await apolloClient.mutate({
        mutation: CHECK_EX,
        variables: {
          seekerId: this.seekerAll.registerSeeker._id,
        },
      });
      this.getCheckEX = res.data.checkSeeker.showStatus;
    },
    async Delete() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: DELETE,
        variables: {
          seekerId: this.seekers.seeker._id,
        },
      });
      this.$router.back();
      window.close();
    },

    OpenModal() {
      this.modalClick = true;
    },
    async querySeekers() {
      const res = await apolloClient.query({
        query: GET_SEEKER_NEW,
        variables: { _id: this.$route.params.id },
      });
      this.seekers = res.data.edit_Seeker;
      if (this.seekers.seeker.registerSeeker) {
        this.isCheckSeeker = true;
        this.seekerName = this.seekers.seeker.registerSeeker.firstName;
        this.seekerLastName = this.seekers.seeker.registerSeeker.lastName;
      }
      this.seekerAll = this.seekers.seeker;
      this.status = this.seekers.seeker.status;
      this.points = this.seekers.seeker.resume.point;
      this.getCheck = this.seekers.seeker.CVStatus;
      this.getCheckEX = this.seekers.seeker.showStatus;
      if (this.seekerAll.resume.fileId) {
        this.PDF = this.seekerAll.resume.fileId.src;
      }
      this.mobile = this.seekers.seeker.mobile;
    },
    async changeStatus() {
      await apolloClient.mutate({
        mutation: CHANGE_SEEKER_STATUS,
        variables: {
          seekerId: this.$route.params.id,
          status: this.status,
          reason: "",
        },
      });
      this.$router.push({
        name: "approved-jobseeker",
        query: {
          type: this.status,
          p: 10,
          q: 1,
          s: "",
        },
      });
    },
    async addPoint() {
      await apolloClient.mutate({
        mutation: ADD_POINT,
        variables: {
          resumeId: this.seekerAll.resume._id,
          point: parseInt(this.myResumes.point),
        },
      });
      this.querySeekers();
      this.points = null;
    },
    async changeMobile() {
      let data = {
        seekerId: this.seekerAll._id ? this.seekerAll._id : "",
        mobile: this.mobile,
      };
      if (!this.mobile) return;
      if (this.seekerAll.authId.mobile === this.mobile) return;
      await apolloClient.mutate({
        mutation: CHANGE_MOBILE,
        variables: data,
      });
    },
  },
  async created() {
    await this.querySeekers();
    this.querySalary();
  },
};
</script>

<style lang="scss">
.profile {
  position: sticky;
  top: 0;
}
.cv-card {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid var(--border-color);
}
.tag {
  cursor: pointer;
  transition: ease-in-out 0.3s;
  &:hover {
    background-color: var(--grey-color);
  }
}
.page-content-header {
  border-bottom: 1px solid var(--border-color);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .page-content-header-start {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .page-content-header-end {
    display: flex;
    align-items: center;
    .field {
      display: flex;
      align-items: center;
      gap: 10px;
      label {
        white-space: pre;
      }
    }
  }
}
</style>
